import { render, staticRenderFns } from "./SfInput.vue?vue&type=template&id=f53ec1e4&scoped=true&"
import script from "./SfInput.vue?vue&type=script&lang=js&"
export * from "./SfInput.vue?vue&type=script&lang=js&"
import style0 from "./SfInput.vue?vue&type=style&index=0&id=f53ec1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53ec1e4",
  null
  
)

export default component.exports